import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';

import rowsPerPageOptions from 'config/rowsPerPageOptions';

import PaymentEventsTableRow from './PaymentEventsTableRow';

const styles = theme => ({
  root: {
    marginTop: 16,
    width: '100%',
  },
  table: {
    minWidth: 500,
  },
  tableHead: {
    position: 'sticky',
    zIndex: 20,
    top: 128,
    '& th:first-child': {
      borderTopLeftRadius: 10,
    },
    '& th:last-child': {
      borderTopRightRadius: 10,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: -8,
      right: -8,
      top: -16,
      zIndex: -1,
      backgroundColor: theme.palette.grey[100],
    },
  },
});

const PaymentEventsTable = ({
  items,
  count,
  page,
  rowsPerPage,
  classes,
  onChangePage,
  onChangeRowsPerPage,
  loading,
}) => (
  <Section className={classes.root}>
    <SectionHeader fixed>
      <SectionTitle>
        Payments Events History
      </SectionTitle>
    </SectionHeader>
    {items.length > 0 &&
      <SectionBody className={classes.sectionBody} padding="none">
        <Table className={classes.table}>
          <TableHead
            className={classes.tableHead}
          >
            <TableRow>
              <TableCell>Event Name</TableCell>
              <TableCell>Event Date</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Plan Name</TableCell>
              <TableCell>Plan Price</TableCell>
              <TableCell>Payment Amount</TableCell>
              <TableCell>Payed From To</TableCell>
              <TableCell>Invoice / Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <PaymentEventsTableRow
                key={item.ID}
                {...item}
              />
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                {...loading === 0 ? {
                  onChangePage,
                  onChangeRowsPerPage,
                } : {
                  onChangePage: () => {},
                  onChangeRowsPerPage: () => {},
                }}
                rowsPerPageOptions={rowsPerPageOptions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </SectionBody>
    }
  </Section>
);

PaymentEventsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  loading: PropTypes.number,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
  }).isRequired,
};

PaymentEventsTable.defaultProps = {
  loading: 0,
};

export default withStyles(styles)(PaymentEventsTable);



// WEBPACK FOOTER //
// ./src/components/settings/PaymentEventsTable/PaymentEventsTable.js